module.exports = __webpack_public_path__ + "static/media/sonne.b7bcb2e0.png";